import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, NgModel, FormControlName } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { AxisValidateDirective } from './axis-validate.directive';
import { AxisInputNumberDirective } from './axis.input.number';
import { AxisInputNumberPipe } from './axis.input.number.pipe';
import { AxisInputNumberParsePipe } from './axis.input.numberparse.pipe';
import { ClearComponent } from './clear.component';
import { ClearIconSharedService } from './clearIcon.sharedService';
import { ClearInputDirective } from './clearInput.directive';
import { AxisInputMaskDirective } from './axis-input-mask-directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    IconModule
  ],
  providers: [ClearIconSharedService, AxisInputNumberPipe, NgModel, FormControlName],
  declarations: [
    AxisInputNumberDirective,
    AxisInputNumberPipe,
    ClearComponent,
    ClearInputDirective,
    AxisValidateDirective,
    AxisInputNumberParsePipe,
    AxisInputMaskDirective
  ],
  exports: [
    AxisInputNumberDirective,
    AxisInputNumberPipe,
    ClearComponent,
    ReactiveFormsModule,
    ClearInputDirective,
    AxisValidateDirective,
    AxisInputNumberParsePipe,
    AxisInputMaskDirective
  ],
  entryComponents: [ClearComponent]
})
export class InputModule {}
